import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { toggleTheme, setTheme, type ThemeMode } from '../store/slices';

/**
 * Hook for managing light/dark theme state.
 */
export function useThemeToggle() {
  const dispatch = useAppDispatch();
  const mode = useAppSelector((state) => state.theme.mode);

  const toggle = useCallback(() => {
    dispatch(toggleTheme());
  }, [dispatch]);

  const set = useCallback(
    (newMode: ThemeMode) => {
      dispatch(setTheme(newMode));
    },
    [dispatch]
  );

  return { mode, toggle, set };
}
